export const PRIVILEGES_TYPES = [
    {id: 'vehicle', label: 'Транспорт'},
    {id: 'user', label: 'Пользователь'},
    {id: 'application', label: 'Разрешения'},
    {id: 'objective', label: 'Объекты'},
    {id: 'subject', label: 'Субъекты'},
    {id: 'address', label: 'Адрес'},
    {id: 'role', label: 'Роли'},
    {id: 'waste_type', label: 'Вид отходов'},
    {id: 'analyst_control', label: 'Аналитика "Контроль перевозчиков'},
    {id: 'analyst_cadastre', label: 'Аналитика "Кадастр отходов'},
    {id: 'admin_cadastre', label: 'Администрирование кадастра'},
    {id: 'reference_information', label: 'Нормативно справочная информация'},
    {id: 'mail', label: 'Отправка почты'},
    {id: 'admin_ter_scheme', label: 'Администрирование Терсхемы'},
    {id: 'lk_kgen', label: 'ЛК КГЭН'},
    {
        id: 'tsoo_balance',
        label: 'Баланс количественных характеристик образования, обработки, утилизации, обезвреживания, размещения твердых коммунальных отходов'
    },
    {
        id: 'tsoo_normative_documents',
        label: 'Нормативные документы'
    },
    {
        id: 'tsoo_active_objects_combined',
        label: 'Действующие объекты обработки, утилизации, обезвреживания, размещения твердых коммунальных отходов, перегрузочные станции'
    },
    {
        id: 'tsoo_planned_objects',
        label: 'Планируемые к строительству, реконструкции, выведению из эксплуатации объекты обработки, утилизации, обезвреживания, размещения твердых коммунальных отходов, перегрузочные станции'
    },
    {id: 'tsoo_flow_scheme', label: 'Схема потоков твердых коммунальных отходов'},
    {
        id: 'tsoo_ro_zones',
        label: 'Сведения о зонах деятельности региональных операторов по обращению с твердыми коммунальными отходами'
    },
    {
        id: 'tsoo_regional_operators',
        label: 'Региональные операторы'
    },
    {
        id: 'tsoo_tko_sources',
        label: 'Сведения об источниках образования твердых коммунальных отходов, в которых осуществляют деятельность потребители услуги по обращению с твердыми коммунальными отходами'
    },
    {id: 'tsoo_accumulation_places', label: 'Сведения о местах (площадках) накопления твердых коммунальных отходов'},
    {
        id: 'tsoo_calculated_values',
        label: 'Расчетные величины образования, обработки, утилизации, обезвреживания, размещения твердых коммунальных отходов, в том числе по зонам деятельности региональных операторов по обращению с твердыми коммунальными отходами'
    },
    {
        id: 'tsoo_agreements',
        label: 'Сведения о соглашениях об организации деятельности по обращению с твердыми коммунальными отходами с региональными операторами по обращению с твердыми коммунальными отходами'
    },
    {
        id: 'tsoo_non_tko_sources',
        label: 'Сведения об источниках образования отходов производства и потребления, не относящихся к твердым коммунальным отходам, о количестве образованных, накопленных, обработанных, обезвреженных, утилизированных и размещенных отходов, не относящихся к твердым коммунальным отходам'
    },
    {
        id: 'tsoo_non_tko_quantity',
        label: 'Сведения о количестве образованных, накопленных, обработанных, утилизированных, обезвреженных, размещенных отходов производства и потребления, не относящихся к твердым коммунальным отходам'
    },
    {
        id: 'tsoo_non_tko_objects',
        label: 'Сведения о действующих и планируемых к строительству (реконструкции) объектах обработки, утилизации, обезвреживания, размещения отходов производства и потребления, не относящихся к твердым коммунальным отходам, и местах их накопления'
    },
    {
        id: 'tsoo_target_indicators',
        label: 'Целевые показатели по обработке (в том числе извлечению из твердых коммунальных отходов вторичных ресурсов), обезвреживанию, утилизации и размещению твердых коммунальных отходов'
    },
    {id: 'tsoo_bio_utilization', label: 'Объекты утилизации, обезвреживания биоотходов'},
    {id: 'tsoo_bio_burning', label: 'Объекты утилизации биологических отходов путем сжигания'},
    {
        id: 'tsoo_manure_storage',
        label: 'Перечень хозяйствующих субъектов (юридические лица и индивидуальные предприниматели) Ленинградской области, в которых имеются навозохранилища (пометохранилища)'
    },
    {id: 'tsoo_burial_grounds', label: 'Перечень скотомогильников (биотермических ям)'},
    {
        id: 'tsoo_capital_investments',
        label: 'Оценка объема соответствующих капитальных вложений в строительство, реконструкцию, выведение из эксплуатации объектов обработки, утилизации, обезвреживания, размещения отходов'
    },
    {
        id: 'tsoo_tariff_forecast',
        label: 'Сведения о прогнозных значениях предельных тарифов в области обращения с твердыми коммунальными отходами'
    },
    {id: 'tsoo_section_management', label: 'Управление разделами электронной модели территориальной схемы'}
];
